import { SystemField } from "./system-field";

export class Objects extends SystemField{
    name?:string;
    table_name?:string;
}
